import {useMemo} from "react";

import {howManyTimesNumberGoesIntoAnotherEvenly} from "../misc";

export const useTimeFilteredData = <D>(
    data: D[],
    selectedRange: number
): {
    filteredData: D[];
    availableRanges: number[];
} => {
    const safeData = Array.isArray(data) ? data : [];

    const filteredData = useMemo(() => {
        if (safeData.length > 0) {
            if (safeData.length < 12) {
                return safeData;
            }
            const slicedData = safeData.slice(safeData.length - selectedRange);
            const hmtngiae = howManyTimesNumberGoesIntoAnotherEvenly(slicedData.length, 12);
            const newData = slicedData.map((el, i) => ((i + 1) % hmtngiae === 0 ? el : null)).filter((el) => el);
            return newData as D[];
        }
        return [];
    }, [safeData, selectedRange]);

    const availableRanges = useMemo(() => {
        const hmtngiae = howManyTimesNumberGoesIntoAnotherEvenly(safeData.length, 12);

        if (!Number.isFinite(hmtngiae) || hmtngiae <= 0) {
            return [];
        }

        const ranges: number[] = new Array(hmtngiae).fill(0).map((_, i) => (i + 1) * 12);

        return ranges;
    }, [safeData]);

    return {
        filteredData,
        availableRanges
    };
};
